var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.barEnter,"leave":_vm.barLeave}},[(_vm.pollAnswered)?_c('div',{staticClass:"score-progress-bar IR-level-2-bg"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }